// This file is auto-generated by @hey-api/openapi-ts

import type {
  Options as ClientOptions,
  TDataShape,
  Client,
} from '@hey-api/client-fetch';
import type {
  GetCabinpresentsData,
  GetCabinpresentsResponse,
  PostCabinpresentsData,
  PostCabinpresentsResponse,
  PostCabinpresentsError,
  PostContestData,
  PostContestResponse,
  PostContestParticipateData,
  PostContestParticipateResponse,
  PostPresignedUrlData,
  PostPresignedUrlResponse,
  PostOfferData,
  PostOfferResponse,
  GetOffersByCruiseTypeData,
  GetOffersByCruiseTypeResponse,
  PostOffersByCruiseTypeData,
  PostOffersByCruiseTypeResponse,
  PostOffersByCruiseTypeError,
  PostLotteryData,
  PostLotteryResponse,
  PostLotteryError,
  PostVotingData,
  PostVotingResponse,
  PostVotingError,
  GetVotingByVotingCodeData,
  GetVotingByVotingCodeResponse,
  GetVotingByVotingCodeError,
  PostVoucherData,
  PostVoucherResponse,
  PostVoucherError,
} from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = ClientOptions<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * returns all cabinpresents grouped by cabinpresent category
 */
export const getCabinpresents = <ThrowOnError extends boolean = false>(
  options?: Options<GetCabinpresentsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetCabinpresentsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'x-api-Key',
        type: 'apiKey',
      },
      {
        name: 'user-agent',
        type: 'apiKey',
      },
      {
        name: 'X-Forwarded-For',
        type: 'apiKey',
      },
    ],
    url: '/cabinpresents',
    ...options,
  });
};

/**
 * book cabinpresents
 */
export const postCabinpresents = <ThrowOnError extends boolean = false>(
  options: Options<PostCabinpresentsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostCabinpresentsResponse,
    PostCabinpresentsError,
    ThrowOnError
  >({
    security: [
      {
        name: 'x-api-Key',
        type: 'apiKey',
      },
      {
        name: 'user-agent',
        type: 'apiKey',
      },
      {
        name: 'X-Forwarded-For',
        type: 'apiKey',
      },
    ],
    url: '/cabinpresents',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const postContest = <ThrowOnError extends boolean = false>(
  options?: Options<PostContestData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    PostContestResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'x-api-Key',
        type: 'apiKey',
      },
    ],
    url: '/contest',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const postContestParticipate = <ThrowOnError extends boolean = false>(
  options?: Options<PostContestParticipateData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    PostContestParticipateResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'x-api-Key',
        type: 'apiKey',
      },
    ],
    url: '/contest/participate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const postPresignedUrl = <ThrowOnError extends boolean = false>(
  options?: Options<PostPresignedUrlData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    PostPresignedUrlResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'x-api-Key',
        type: 'apiKey',
      },
    ],
    url: '/presigned-url',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const postOffer = <ThrowOnError extends boolean = false>(
  options?: Options<PostOfferData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    PostOfferResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'x-api-Key',
        type: 'apiKey',
      },
      {
        name: 'user-agent',
        type: 'apiKey',
      },
      {
        name: 'X-Forwarded-For',
        type: 'apiKey',
      },
    ],
    url: '/offer',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * get available offers for "cruiseType"
 */
export const getOffersByCruiseType = <ThrowOnError extends boolean = false>(
  options: Options<GetOffersByCruiseTypeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetOffersByCruiseTypeResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'x-api-Key',
        type: 'apiKey',
      },
      {
        name: 'user-agent',
        type: 'apiKey',
      },
      {
        name: 'X-Forwarded-For',
        type: 'apiKey',
      },
    ],
    url: '/offers/{cruiseType}',
    ...options,
  });
};

/**
 * book a available offer.
 * - commit: true => book offer
 * - commit: false => get offer prices
 *
 */
export const postOffersByCruiseType = <ThrowOnError extends boolean = false>(
  options: Options<PostOffersByCruiseTypeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostOffersByCruiseTypeResponse,
    PostOffersByCruiseTypeError,
    ThrowOnError
  >({
    security: [
      {
        name: 'x-api-Key',
        type: 'apiKey',
      },
      {
        name: 'user-agent',
        type: 'apiKey',
      },
      {
        name: 'X-Forwarded-For',
        type: 'apiKey',
      },
    ],
    url: '/offers/{cruiseType}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const postLottery = <ThrowOnError extends boolean = false>(
  options: Options<PostLotteryData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostLotteryResponse,
    PostLotteryError,
    ThrowOnError
  >({
    security: [
      {
        name: 'x-api-Key',
        type: 'apiKey',
      },
      {
        name: 'user-agent',
        type: 'apiKey',
      },
      {
        name: 'X-Forwarded-For',
        type: 'apiKey',
      },
    ],
    url: '/lottery',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Add new voting for user.
 * User must provide api key (x-api-key) in header for non anonymous request.
 * Or user-agent (user-agent)  and user ip (X-Forwarded-For) in header for anonymous request.
 *
 */
export const postVoting = <ThrowOnError extends boolean = false>(
  options: Options<PostVotingData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostVotingResponse,
    PostVotingError,
    ThrowOnError
  >({
    security: [
      {
        name: 'x-api-Key',
        type: 'apiKey',
      },
      {
        name: 'user-agent',
        type: 'apiKey',
      },
      {
        name: 'X-Forwarded-For',
        type: 'apiKey',
      },
    ],
    url: '/voting',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Return voting data for a user.
 * User must provide api key (x-api-key) in header for non anonymous request.
 * Or user-agent (user-agent)  and user ip (X-Forwarded-For) in header for anonymous request. If the user has not voted yet, the response does not include the field 'myChoices'.
 * If no valid user informations are provided, the requests is handelt in no user mode and the response only contain the general voting data without the 'user' field.
 *
 */
export const getVotingByVotingCode = <ThrowOnError extends boolean = false>(
  options: Options<GetVotingByVotingCodeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetVotingByVotingCodeResponse,
    GetVotingByVotingCodeError,
    ThrowOnError
  >({
    security: [
      {
        name: 'x-api-Key',
        type: 'apiKey',
      },
      {
        name: 'user-agent',
        type: 'apiKey',
      },
      {
        name: 'X-Forwarded-For',
        type: 'apiKey',
      },
    ],
    url: '/voting/{votingCode}',
    ...options,
  });
};

export const postVoucher = <ThrowOnError extends boolean = false>(
  options: Options<PostVoucherData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostVoucherResponse,
    PostVoucherError,
    ThrowOnError
  >({
    security: [
      {
        name: 'x-api-Key',
        type: 'apiKey',
      },
      {
        name: 'user-agent',
        type: 'apiKey',
      },
      {
        name: 'X-Forwarded-For',
        type: 'apiKey',
      },
    ],
    url: '/voucher',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};
